import BaseView from '@/store/modules/components/BaseView'

export default class UsersView extends BaseView {
    constructor() {
        super('users')
    }
}
